/* eslint-disable max-statements */
/* eslint-disable camelcase */
import { findByKey } from "../helpers/find-by-key";
import { isValidDateAndTime } from "../helpers/is-valid-date-time-appointment";
import { APPOINTMENT_TYPE, APPOINTMENT_SCREEN } from "../../constants/app-constants";

// eslint-disable-next-line complexity
export const restoreAppointment = (state, data) => {
    const {
        location_id, date, time,
        verified, appointment_id, loc,
        appointment_geo_data,
        appointment_loans,
        pincode,
        city_name
    } = data;
    const {
        appointmentDate = date,
        appointmentTime = time
    } = state;
    const selectedInspectionType = state.zone && loc !== 1 ? "inspection" : "branch";
    let selectedBranch = parseInt(selectedInspectionType === "inspection" ?
        state.zone.location_id : location_id);

    const slots = state.slots[selectedBranch];

    const showPreSelectedBranch = () => {
        return (
            selectedInspectionType === APPOINTMENT_TYPE.BRANCH &&
            selectedBranch &&
            slots
        );
    };

    let selectedInspectionDate = null;
    let selectedInspectionTime = null;
    let address = null;
    let landmark = null;
    let appointmentScreen = APPOINTMENT_SCREEN.DEFAULT;

    if (slots) {
        const dateSlots = slots.date_slot;
        const inspectionDate = findByKey(dateSlots, "date", date);
        const timeSlots = inspectionDate.time;
        const inspectionTime = findByKey(timeSlots, "value", time);
        const parsedTime = (
            inspectionTime.value && inspectionTime.status) !== "NA" ?
            inspectionTime.value : null;
        selectedInspectionDate = inspectionDate.date || null;
        selectedInspectionTime = parsedTime;
    } else {
        //if slots doesn't exist, then we should reset the last selected branch
        selectedBranch = null;
    }
    // const dateSlots = slots.date_slot;
    // const selectedInspectionDate = findByKey(dateSlots, "date", date);
    // const timeSlots = selectedInspectionDate.time;
    // const selectedInspectionTime = findByKey(timeSlots, "value", time);

    // const parsedTime = (
    //     selectedInspectionTime.value && selectedInspectionTime.status) !== "NA" ?
    //     selectedInspectionTime.value : null;

    if (selectedInspectionType === APPOINTMENT_TYPE.HOME) {
        const { address1, address2 } = appointment_geo_data || {};
        address = address1;
        landmark = address2;
        const showAddressCaptureScreen = (
            (appointment_id && (!address || !landmark)) ||
            (address && landmark && !verified)
        );

        const {isInvalidAppointmentDate, isInvalidAppointmentTime} = isValidDateAndTime(appointmentDate, appointmentTime, state.slots, selectedBranch);

        if (showAddressCaptureScreen) {
            appointmentScreen = APPOINTMENT_SCREEN.ADDRESS;
        }
        if (isInvalidAppointmentDate || isInvalidAppointmentTime) {
            appointmentScreen = APPOINTMENT_SCREEN.BOOKING;
        }
    }
    if (showPreSelectedBranch()) {
        appointmentScreen = APPOINTMENT_SCREEN.BOOKING;
    }

    let loanAttributes = {};
    if (appointment_loans) {
        loanAttributes = { ...appointment_loans };
    }

    return {
        ...state,
        selectedBranch,
        selectedInspectionDate,
        selectedInspectionTime,
        isVerified: verified,
        appointmentID: appointment_id,
        apiInProgress: false,
        selectedInspectionType,
        address,
        landmark,
        appointmentScreen,
        loanAttributes,
        appointmentPincode: pincode,
        appointmentCity: city_name,
        date,
        time
    };
};
